import { Component, Input, OnInit, OnChanges, OnDestroy, ChangeDetectionStrategy } from "@angular/core";
import { Platform, PopoverController } from "@ionic/angular";
import { Subscription } from "rxjs";
import { LogLevel } from "src/components/shared-components/enum/enumLog";
import { iEvent } from "src/components/shared-components/interfaces/iEvent";
import { EventService } from "src/service/event.service";
import { LoggerService } from "src/service/logger.service";
import { MediaService } from "src/service/media.service";

@Component({
    selector: "app-choose-file",
    templateUrl: "./choose-file.component.html",
    styleUrls: ["./choose-file.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

/**
 * This component handle file chooser
 * Optional parameter:
 * allowMultipleSelection: allow user to select multiple files if set to true
 */
export class ChooseFileComponent
  implements OnInit, OnDestroy, OnChanges, iEvent {
  private _logContext: string = "Choose-file.component";
  public _eventSubscriptions: Array<Subscription> = null;

  public multipleSelectedAttribute: string = "";
  public multipleAcceptFile: string = "";

  //ATTENTION! CHANGE THIS TO USE NEW Enum
  @Input() allowMultipleSelection: boolean;
  @Input() allowedMediaTypeApp: Array<string>;
  @Input() allowedMediaTypeBrowser: Array<string>;
  @Input() onlyReturnFileObject: boolean = false;

  constructor(
    private _platform: Platform,
    private _mediaService: MediaService,
    private _popoverService: PopoverController,
    private _eventService: EventService,
    private _loggerService: LoggerService
  ) { }

  ngOnInit() {
    //ATTENTION! CHANGE THIS TO USE NEW Enum
    if (
      this.allowedMediaTypeApp &&
      Array.isArray(this.allowedMediaTypeApp) &&
      this.allowedMediaTypeBrowser &&
      Array.isArray(this.allowedMediaTypeBrowser)
    ) {
      if (this._platform.is("ios") || this._platform.is("android")) {
        this.multipleAcceptFile = this.allowedMediaTypeApp.join(",");
      } else {
        this.multipleAcceptFile = this.allowedMediaTypeBrowser.join(",");
      }
    }

    this.subscribeEvents();
  }

  ngOnDestroy(): void {
    this.unsubscribeEvents();
  }

  ngOnChanges() {
    if (
      this.allowedMediaTypeApp &&
      Array.isArray(this.allowedMediaTypeApp) &&
      this.allowedMediaTypeBrowser &&
      Array.isArray(this.allowedMediaTypeBrowser)
    ) {
      if (this._platform.is("ios") || this._platform.is("android")) {
        this.multipleAcceptFile = this.allowedMediaTypeApp.join(",");
      } else {
        this.multipleAcceptFile = this.allowedMediaTypeBrowser.join(",");
      }
    }
  }

  //#region Subscribe to event-service observable
  subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    this._eventSubscriptions.push(
      this._eventService.OnMakeForceLogout.subscribe(() => {
        this._popoverService.dismiss();
      })
    );
  }

  unsubscribeEvents(): void {
    for (let sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
  }
  //#endregion

  /**
   * Input type file change event.
   * Check if some file are selected and then upload it to server
   */
  onUploadFiles(filesToUpload: any) {
    if (filesToUpload.length === 0) {
      return;
    }

    if (this.onlyReturnFileObject) {
      this._popoverService.dismiss(filesToUpload);
    } else {
      for (let file of filesToUpload) {
        this.loadFilesOnServer(file);
      }
    }
  }

  /**
   * Open effectivly file chooser componsent
   */
  public onRequestOpenFileChooser() {
    document.getElementById("input-file-chooser").click();
  }

  /**
   * Upload single file to server
   */
  private async loadFilesOnServer(fileToUpload: File) {
    try {
      const result = await this._mediaService.uploadFileToServer(fileToUpload);
    } catch (exception) {
      this._loggerService.log(
        LogLevel.LOG_ERROR,
        this._logContext,
        this._logContext,
        "loadFilesOnServer()",
        "Error: " + exception.message
      );
    }
  }
}
